export const survivalPlotContainer = 'tid_survival-plot-container';
export const survivalPlotLine = 'tid_survival-plot-line';
export const survivalLegend = 'tid_survival-legend';
export const survivalLegendBox = 'tid_survival-legend-box';
